import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { CityInput } from "@/components/elements/CityInput";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { useFormContext } from "react-hook-form";
import UploadLogo from "@/features/company/components/company-info/UploadLogo";
import { useLocationInfo } from "@/hooks/useLocationInfo";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { PLACEHOLDER_LOCATION_FIELD } from "@/features/company/constants/string";

type TCompanyBasicInfoProps = {
  readonly?: boolean;
};

export const CompanyBasicInfo: FC<TCompanyBasicInfoProps> = ({ readonly }) => {
  const methods = useFormContext<TCompanyForm>();
  const { control } = methods;

  const locationInfo = useLocationInfo({
    methods,
    names: { zipCode: "zipCode", province: "prefecture", municipality: "city", address: "address" },
  });
  return (
    <Stack gap={2}>
      <InnerBox title={<CompanyFormTitle text="企業基本情報" />} showDivider={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={1}>
                <UploadLogo />
              </Grid>
              <Grid item xs={11}>
                <FormField control={control} name="managementNumber">
                  <Input />
                </FormField>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="companyName">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="companyKanaName">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="establishmentYear">
              <Input readonly={readonly} endAdornment="年" />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="capital">
              <Input readonly={readonly} commasFormat={true} clearable={false} endAdornment="円" />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="numberOfEmployees">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="representativeName">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="representativePosition">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="telNumber">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="faxNumber">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="contactEmail">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="websiteUrl">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="zipCode" isMessageNowrap>
              <Input readonly={readonly} placeholder={PLACEHOLDER_LOCATION_FIELD} />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <FormField control={control} name="prefecture">
              <Input readonly />
            </FormField>
          </Grid>
          <Grid item xs={4}>
            <CityInput name="city" control={control} zipCodeFieldName="zipCode" locationInfo={locationInfo} />
          </Grid>
          <Grid item xs={12}>
            <FormField control={control} name="address">
              <Input readonly={readonly} placeholder={PLACEHOLDER_LOCATION_FIELD} />
            </FormField>
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
